module.exports = __webpack_public_path__ + "img/L3B.177f97e1.jpg";